import { useEffect, useState } from "react";
import { api } from "@/lib/pfc";
import { useAuth } from "@/contexts/AuthContext";
import { Gift, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function DailyBonusToast() {
  const { user } = useAuth();
  const [bonus, setBonus] = useState(null);

  useEffect(() => {
    if (!user) return;
    const todayKey = `pfc_daily_bonus_${new Date().toISOString().slice(0, 10)}_${user.user_id}`;
    try {
      if (sessionStorage.getItem(todayKey) === "1") return;
    } catch {/* noop */}
    // Try claim once per app load per day
    api.post("/casino/daily-bonus")
      .then((r) => {
        try { sessionStorage.setItem(todayKey, "1"); } catch {/* noop */}
        if (r.data?.claimed && r.data.credits_added > 0) {
          setBonus(r.data);
        }
      })
      .catch(() => {});
  }, [user]);

  if (!bonus) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-[55] pfc-card border-pfc-gold/60 bg-ink-800 shadow-2xl shadow-pfc-gold/20 p-5 max-w-sm animate-in slide-in-from-bottom"
      data-testid="daily-bonus-toast"
    >
      <button
        onClick={() => setBonus(null)}
        className="absolute top-2 right-2 text-white/40 hover:text-white p-1"
        data-testid="daily-bonus-dismiss"
      >
        <X size={14} />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-pfc-gold/20 border border-pfc-gold/40 flex items-center justify-center" style={{ borderRadius: 8 }}>
          <Gift className="text-pfc-gold" size={22} />
        </div>
        <div className="flex-1">
          <div className="label text-pfc-gold mb-1">Daily PFC Bonus</div>
          <p className="font-display text-2xl text-white">
            +<span className="gold-text">{bonus.credits_added}</span> Credits
          </p>
          <p className="text-white/55 text-xs font-body mt-1">
            Balance: {bonus.new_balance} · Come back tomorrow for more.
          </p>
          <Link
            to="/casino"
            onClick={() => setBonus(null)}
            className="inline-block mt-3 font-sub uppercase tracking-[0.25em] text-[10px] text-pfc-gold hover:text-pfc-gold-bright transition"
          >
            Play Casino →
          </Link>
        </div>
      </div>
    </div>
  );
}
